export default __webpack_public_path__ + "static/media/footer-1.464ad3a5.jpg";